import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // this will be passed from the route config on the data property
    const expectedRole: string[] = route.data.expectedRole;
    const accountRole = this.authService.getUserRole();
    const matchedRole = accountRole.some((item) => expectedRole.includes(item));
    if (!this.authService.loggedIn() || !matchedRole) {
      console.log('RoleGuard: not logged in or no matched role', state);
      this.router.navigate(['/sb/unauthorized']);
      return false;
    }
    return true;
  }
}
